import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { chatActions } from '../../actions';
import { FillRecentChatsActionPayload } from '@bus/chat/typedefs';

export function* fetchRecentChats() {
  try {
    yield effects.put(chatActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: 'chats/recent/' },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }

    const data: FillRecentChatsActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(chatActions.fillRecentChats(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(chatActions.stopFetching());
  }
}
